import { atom } from "klyva";

const getStoredSession = () => {
  if (typeof window === "undefined") return null;

  const storages = [localStorage, sessionStorage];

  for (const storage of storages) {
    try {
      const rawSession = storage.getItem("user_session");
      if (!rawSession) continue;

      const parsedSession = JSON.parse(rawSession);
      if (parsedSession && parsedSession.isAuthenticated === true) {
        return parsedSession;
      }
    } catch (error) {
      // Ignore invalid session payloads and continue checking fallbacks.
    }
  }

  return null;
};

export const authStore = atom<{ isAuthenticated: boolean }>({
  isAuthenticated: !!getStoredSession(),
});

export const login = () => {
  authStore.update(() => ({ isAuthenticated: true }));
};

export const logout = () => {
  authStore.update(() => ({ isAuthenticated: false }));
};